import { type ReactNode } from 'react';
import { Input } from '@/components/ui/input';
import { EditSelects } from './creator-edit-selects';
import { type EditFormState } from './creator-edit-fields.helpers';

export type { EditFormState } from './creator-edit-fields.helpers';

type Props = {
  form: EditFormState;
  setForm: (s: EditFormState) => void;
  emailValid: boolean;
};

export function CreatorEditFields(p: Props): ReactNode {
  return (
    <div className="grid grid-cols-2 gap-sm">
      <div className="col-span-2">
        <Input
          label="Email"
          value={p.form.email}
          onChange={(e) => p.setForm({ ...p.form, email: e.target.value })}
          error={p.emailValid ? '' : 'Email inválido'}
        />
      </div>
      <EditSelects form={p.form} setForm={p.setForm} />
      <div className="col-span-2">
        <Input
          label="Notas"
          value={p.form.notes}
          onChange={(e) => p.setForm({ ...p.form, notes: e.target.value })}
        />
      </div>
    </div>
  );
}
